import { CircularProgressContinuousSized } from '@/components/loaders/CircularProgressContinuous'
import { selectSkillIsInitializing } from '../store/selectors'
import { RootState } from '@/store/store'
import { useAppSelector } from '@/store/store-hooks'
import { SkillContent } from '../store/schemas'
import SkillChipIcon from './SkillChipIcon'

interface SkillChipProps {
  content: SkillContent
  onClick: () => void
}

export default function SkillChip(props: SkillChipProps) {
  const { content, onClick } = props

  const skillInitLoading = useAppSelector((state: RootState) => state.skillsState.skillInitLoading)
  const loading = useAppSelector((state: RootState) => selectSkillIsInitializing(state, { skill: content.skill }))

  // Disable skill clicks if any skill is initializing
  const disableSkillClicks = Boolean(skillInitLoading)

  /**
   * Determine Skill Icon
   *
   * Returns the appropriate icon based on the loading and error state.
   */
  function DetermineSkillIcon() {
    switch (true) {
      case loading: {
        return <CircularProgressContinuousSized size={20} hexColor="#76736a" className={'p-[1px]'} thickness={6} />
      }
      default: {
        return <SkillChipIcon skill={content.skill} />
      }
    }
  }

  // shadow-[inset_0_0_0_0_#F0EBE2] -> inset border
  return (
    <button
      className={
        'group inline-block rounded-lg bg-white hover:bg-brand-neutral-100 border border-brand-neutral-200 py-0 text-sm text-brand-neutral-800 hover:text-brand-500 transition-all duration-300 font-medium shadow-[inset_0_0_0_0_#F0EBE2]'
      }
      disabled={disableSkillClicks}
      onClick={onClick}
    >
      <div className={'flex flex-nowrap items-center'}>
        <div className={'grow h-full border-r border-brand-neutral-200 flex items-center'}>
          <div className={'grow flex items-center h-full px-2 py-2'}>
            <DetermineSkillIcon />
          </div>
        </div>
        <div>
          <div className={'text-nowrap pl-2 pr-3'}>{content.label}</div>
        </div>
      </div>
    </button>
  )
}
